export default function AdminIconButton({ label, icon: Icon, className = '', title = label, ...props }) {
  return <button type="button" className={`admin-icon-button ${className}`} aria-label={label} title={title} {...props}>
    <Icon aria-hidden="true" focusable="false" />
  </button>;
}
